import React from "react";
import Radio from "@material-ui/core/Radio";
import { colors } from "../../styles/colors";
import { createMuiTheme, ThemeProvider, withStyles } from "@material-ui/core";

const DebrisTrackerRadio = withStyles({
  root: {
    color: colors.white,
  },
})(Radio);

const customTheme = createMuiTheme({
  palette: {
    primary: { main: colors.white },
  },
});

const RadioButton = ({
  onChange,
  checked,
  name,
  children,
}: {
  onChange?: (e: any) => void;
  checked?: boolean;
  name?: string;
  children?: any;
}) => {
  return (
    <ThemeProvider theme={customTheme}>
      <div>
        <DebrisTrackerRadio
          color="primary"
          onChange={onChange}
          checked={checked}
          id={`radio-${name}`}
          name="date_type"
          value={name}
        />
        <span>{children}</span>
      </div>
    </ThemeProvider>
  );
};

export default RadioButton;
